import { render, staticRenderFns } from "./person.vue?vue&type=template&id=50af2575&scoped=true&"
import script from "./person.vue?vue&type=script&lang=js&"
export * from "./person.vue?vue&type=script&lang=js&"
import style0 from "./person.vue?vue&type=style&index=0&id=50af2575&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50af2575",
  null
  
)

export default component.exports